import React from "react";
import useFetch from "@/lib/useFetch";
import { GlassCard, PageTitle } from "@/components/lux";
import { Users, UserPlus, Eye, Wallet, TrendingUp } from "lucide-react";

const SRC_LABEL = { google: "Google", facebook: "Facebook", instagram: "Instagram", direct: "Direct", other: "Other" };

function StatRow({ o }) {
  if (!o) return <div className="skeleton h-24" />;
  const items = [
    ["Visits", o.page_view, Eye],
    ["Unique Visitors", o.unique_visitors, Users],
    ["Reg. Started", o.registration_started, UserPlus],
    ["Registrations", o.registration_completed, UserPlus],
    ["Deposit Views", o.deposit_page_view, Wallet],
    ["Deposits", o.deposit_completed, Wallet],
  ];
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
      {items.map(([l, v, Icon]) => (
        <div key={l} className="rounded-xl glass-2 p-3" data-testid={`mkt-${l.replace(/\W+/g, "-").toLowerCase()}`}>
          <div className="mb-1 flex items-center gap-1.5 text-[var(--text-dim)]"><Icon size={13} /><span className="text-[11px]">{l}</span></div>
          <p className="text-xl font-bold text-white">{v ?? 0}</p>
        </div>
      ))}
    </div>
  );
}

function Conv({ o }) {
  if (!o) return null;
  return (
    <div className="mt-3 flex flex-wrap gap-4 text-xs">
      <span className="text-[var(--text-dim)]">Reg. conversion: <b className="text-emerald-400">{o.reg_conversion}%</b></span>
      <span className="text-[var(--text-dim)]">Deposit conversion: <b className="text-[var(--gold)]">{o.deposit_conversion}%</b></span>
    </div>
  );
}

export default function AdminMarketing() {
  const { data: ov } = useFetch("/admin/marketing/overview");
  const { data: sr } = useFetch("/admin/marketing/sources");
  const periods = [["Today", "today"], ["Yesterday", "yesterday"], ["Last 7 Days", "last7"], ["Last 30 Days", "last30"], ["All Time", "all_time"]];
  const srcTotal = sr ? Object.values(sr.sources).reduce((a, b) => a + b, 0) : 0;
  return (
    <div className="space-y-6">
      <PageTitle title="Visitor Analytics" subtitle="Aggregate visitor & conversion stats (no personal data stored)" />
      {periods.map(([label, key]) => (
        <GlassCard className="p-6" key={key} data-testid={`mkt-period-${key}`}>
          <div className="mb-4 flex items-center gap-2"><TrendingUp size={16} className="text-[var(--gold)]" /><h3 className="font-semibold text-white">{label}</h3></div>
          <StatRow o={ov?.[key]} />
          <Conv o={ov?.[key]} />
        </GlassCard>
      ))}
      <GlassCard className="p-6" data-testid="mkt-sources">
        <h3 className="mb-4 font-semibold text-white">Traffic Sources (Last 30 Days)</h3>
        {!sr ? <div className="skeleton h-24" /> : (
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-5">
            {Object.entries(sr.sources).map(([k, v]) => (
              <div key={k} className="rounded-xl glass-2 p-3" data-testid={`mkt-src-${k}`}>
                <p className="text-[11px] text-[var(--text-dim)]">{SRC_LABEL[k]}</p>
                <p className="text-xl font-bold text-white">{v}</p>
                <p className="text-[10px] text-[var(--text-dim)]">{srcTotal ? Math.round((v / srcTotal) * 100) : 0}%</p>
              </div>
            ))}
          </div>
        )}
      </GlassCard>
    </div>
  );
}
